import React from 'react';
import { OutlinedInput } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './bank-sort-code-number.module.scss';
import NumberFormat from 'react-number-format';

function BankSortCodeNumberComponent(props) {
    const {
        firstInputElementRef,
        secondInputElementRef,
        thirdInputElementRef,
        firstInputChangeHandler,
        secondInputChangeHandler,
        thirdInputChangeHandler,
        firstInputValues,
        secondInputValues,
        thirdInputValues,
        hideDashes,
        disabled,
        emptyField
    } = props;

    return (
        <div className={styles.wrapper}>
            <NumberFormat
                className={`${
                    disabled
                        ? styles.wrapper__inputs + ' ' + styles.wrapper__inputs__disableInput
                        : styles.wrapper__inputs
                } ${emptyField || !firstInputValues ? styles.wrapper__inputs__emptyInput : ''}`}
                customInput={OutlinedInput}
                inputProps={{ inputMode: 'numeric', ref: firstInputElementRef, maxLength: 2 }}
                pattern="\d*"
                allowLeadingZeros={true}
                decimalSeparator={false}
                allowNegative={false}
                isNumericString={true}
                placeholder="00"
                value={firstInputValues}
                onValueChange={firstInputChangeHandler}
                labelWidth={0}
                required
                disabled={disabled ? true : false}
            />
            {!hideDashes && <span className={styles.wrapper__inputs__dash}>-</span>}
            <NumberFormat
                className={`${
                    disabled
                        ? styles.wrapper__inputs + ' ' + styles.wrapper__inputs__disableInput
                        : styles.wrapper__inputs
                } ${emptyField || !secondInputValues ? styles.wrapper__inputs__emptyInput : ''}`}
                customInput={OutlinedInput}
                inputProps={{ inputMode: 'numeric', ref: secondInputElementRef, maxLength: 2 }}
                pattern="\d*"
                allowLeadingZeros={true}
                decimalSeparator={false}
                allowNegative={false}
                isNumericString={true}
                placeholder="00"
                value={secondInputValues}
                onValueChange={secondInputChangeHandler}
                labelWidth={0}
                required
                disabled={disabled ? true : false}
            />
            {!hideDashes && <span className={styles.wrapper__inputs__dash}>-</span>}
            <NumberFormat
                className={`${
                    disabled
                        ? styles.wrapper__inputs + ' ' + styles.wrapper__inputs__disableInput
                        : styles.wrapper__inputs
                } ${emptyField || !thirdInputValues ? styles.wrapper__inputs__emptyInput : ''}`}
                customInput={OutlinedInput}
                inputProps={{ inputMode: 'numeric', ref: thirdInputElementRef, maxLength: 2 }}
                pattern="\d*"
                allowLeadingZeros={true}
                decimalSeparator={false}
                allowNegative={false}
                isNumericString={true}
                placeholder="00"
                value={thirdInputValues}
                onValueChange={thirdInputChangeHandler}
                labelWidth={0}
                maxLength={2}
                required
                disabled={disabled ? true : false}
            />
        </div>
    );
}

BankSortCodeNumberComponent.propTypes = {
    firstInputChangeHandler: PropTypes.func,
    secondInputChangeHandler: PropTypes.func,
    thirdInputChangeHandler: PropTypes.func,
    firstInputValues: PropTypes.string,
    secondInputValues: PropTypes.string,
    thirdInputValues: PropTypes.string,
    hideDashes: PropTypes.bool
};

export default BankSortCodeNumberComponent;
